// extracted by mini-css-extract-plugin
module.exports = {"title-row":"TitleRow_title-row__32fib","prices-sent":"TitleRow_prices-sent__26yYX"};